import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService, AuthState, QrCodeUtilsService, TokenService } from 'sbs-common'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService,
    private qrCodeUtilsService: QrCodeUtilsService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = this.tokenService.getUser()
    const urlParams = route.queryParams
    if (urlParams.qrCode) {
      this.qrCodeUtilsService.saveQrCode(urlParams.qrCode)
    }
    if (!user) {
      this.authService.navigateUserToCorrectPath(null)
    }
    return true
  }
}
